import React from 'react';

function Home() {
    return (
        <g>
            <path d="M0.5,12.5H2V22c0,0.3,0.2,0.5,0.5,0.5h7c0.3,0,0.5-0.2,0.5-0.5v-5.5h4V22c0,0.3,0.2,0.5,0.5,0.5h7c0.3,0,0.5-0.2,0.5-0.5
                v-9.5h1.5c0.2,0,0.4-0.1,0.5-0.3c0.1-0.2,0-0.4-0.1-0.6L20,8.3V5c0-0.3-0.2-0.5-0.5-0.5h-3c-0.2,0-0.4,0.1-0.5,0.3l-3.7-3.2
                c-0.2-0.2-0.5-0.2-0.7,0l-11.5,10C0,11.8,0,12,0,12.2C0.1,12.4,0.3,12.5,0.5,12.5z M12,2.7l4.2,3.6c0.1,0.1,0.4,0.2,0.5,0.1
                C16.9,6.3,17,6.1,17,5.9V5.5h2v3c0,0.1,0.1,0.3,0.2,0.4l3,2.6h-0.7c-0.3,0-0.5,0.2-0.5,0.5v9.5h-6V16c0-0.3-0.2-0.5-0.5-0.5h-5
                C9.2,15.5,9,15.7,9,16v5.5H3V12c0-0.3-0.2-0.5-0.5-0.5H1.8L12,2.7z"
            />
        </g>
    );
}

export default Home;
